import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SupportChat from '../chat';
import { getAuthElemStyle, getProject } from '../../../common/tools';
import { INewTicketSupport } from '../interfaces';
import { toast } from 'react-toastify';
import { createTicket } from '../../../stores/support.store';
import { MainContext } from '../../../context/main.context';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Header from '../../header';
import Footer from '../../footer';
import SupportTickets from '../tickets';


export default function SupportTicketCreate(props: { firstTicketCreate?: boolean }) {
    const [ searchParams ] = useSearchParams();
    const first: string | null = searchParams.get('first');

    const firstTicketCreate = props?.firstTicketCreate || first === '1';
    const { t } = useTranslation();
    const {
        toggleLoader,
        modalContent,
        settings,
        setModalContent,
        getSupportUnreadMessageCountPublic,
        project
    } = useContext(MainContext);
    const navigate = useNavigate();

    const [ title, setTitle ] = useState<string>('');
    const titleRef = useRef<any>(title);

    useEffect(() => {
        titleRef.current = title;
    }, [ title ]);

    const _renderTicketTitle = useCallback(() => {
        return (
            <div className="support-create-ticket-title">
                <span className="support-create-ticket-description">{t('support.subject')}:</span>
                <input
                    className="support-create-ticket-title-input"
                    type="text"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    placeholder={t('support.requestTitleDescription')}
                />
            </div>
        );
    }, [ title ]);

    const _onSubmit = (text: string | null, image: File | null = null, video: File | null = null) => {
        const ticketTitle: string = titleRef.current || `${t('support.ticketTitlePlug')} ${project || getProject()}`;

        const formData: FormData = new FormData();

        const newTicket: INewTicketSupport = {
            title: ticketTitle,
        };

        if (text) {
            newTicket.text = text;
        }

        if (image) {
            formData.append('image', image as File);
        }

        if (video) {
            formData.append('video', video as File);
        }

        formData.append('data', JSON.stringify(newTicket));

        _createTicket(formData);
    }

    const _createTicket = (formData: FormData) => {
        toggleLoader(true);

        createTicket(formData).then(res => {
            const newTicketId: string = res?.data?.id;

            if (!newTicketId) {
                toast.error('CREATE_TICKET_ERROR');
                console.error('CREATE_TICKET_ERROR', { res });
                return;
            }

            setTitle('');

            getSupportUnreadMessageCountPublic();

            if (settings?.projects?.authType === 'postMessage') {
                setModalContent({ component: <SupportTickets/>, className: 'support-tickets-modal' });
                return;
            }

            navigate(`/support/ticket?id=${newTicketId}`);
        }, err => {
            toast.error('CREATE_TICKET_ERROR');
            console.error('CREATE_TICKET_ERROR', { err })
        }).finally(() => {
            toggleLoader(false);
        });
    }

    const _renderTicketChat = useCallback(() => {
        return (
            <>
                <span className="support-create-ticket-description-editor">{t('support.description')}:</span>
                <SupportChat
                    classNameValue="support-ticket-create-chat-container-ql"
                    onSubmit={_onSubmit}
                    placeholder={t('support.requestDescription')}
                />
            </>
        );
    }, [ t ]);

    return (
        <div
            className="auth support"
            style={{ background: !modalContent ? '#e8e8e8' : 'unset' }}
        >
            <div
                className="auth-container"
                style={{
                    background: !modalContent ? '#e8e8e8' : 'unset',
                    minHeight: !modalContent ? 'calc(100vh - 100px)' : '100%',
                }}
            >
                <div className="auth-modal support" style={getAuthElemStyle(settings)}>
                    <Header origin={firstTicketCreate ? 'firstTicketCreate' : 'ticketCreate'}/>
                    <div className="support-ticket-create-chat-container">
                        {_renderTicketTitle()}
                        {_renderTicketChat()}
                    </div>
                </div>
            </div>
            { !modalContent && <Footer/> }
        </div>
    );
}